import React from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const BackBtn = ({ btn_name, form_path, icon, padding = "2.8",marginTop=true }) => {
  const navigate = useNavigate();
  const handleAction = () => {
    navigate(-1);
  };
  return (
    <Button
      style={{
        padding: `${padding}px`,
        width: "60px",
        borderRadius: "6px",
        textDecoration: "none",
        marginTop: marginTop ? "8px" :"",
      }}
      type="button"
      className="fluid me-2 btn btn-success"
      onClick={handleAction}
    >
      <div
        style={{
          display: "flex",
          padding: "2px",
          justifyContent: "center",
          alignItems: "center",
          textDecoration: "none",
        }}
      >
        {icon}
        {btn_name}
      </div>
    </Button>
  );
};

export default BackBtn;
